import type { CsBrandKit } from '../../../../common/models/content-studio.model';
import { VideoBrand, brandFromKit } from './presets';

let cached: Promise<VideoBrand> | null = null;

/**
 * The vendor's brand kit, read once per page load for the editor and the
 * templates. A failure is an empty brand, never an error: every template
 * works without one.
 */
export function loadVideoBrand(getBrandKit: () => Promise<CsBrandKit>): Promise<VideoBrand> {
    if (!cached) {
        cached = getBrandKit().then(brandFromKit).catch(() => {
            cached = null;
            return {};
        });
    }
    return cached;
}
